export interface IContributor{
    id: number;
    firstName: string;
    lastName: string;
    email: string;
    accessLevel: number;
    isOpen?:boolean
}